export default {
  path: '/404',
  name: '404',
  component: () => import('../views/not_found/PageNotFound.vue'),
  meta: {
    layout: 'main'
  }
}